<template>
    <div id="app">
        <!--<img src="./assets/logo.png">-->
        <router-view></router-view>
        <modal></modal>
    </div>
</template>

<script>
    export default {
        name: 'app',

        computed: {
            titleBar(){
                let originalTitle = this.$store.state.titleBarModel.originalTitle,
                    alert = this.$store.state.titleBarModel.alert,
                    divider = this.$store.state.titleBarModel.divider,
                    finalTitleBar = '';

                if (alert) {
                    finalTitleBar += alert + divider
                }

                finalTitleBar += originalTitle;

                return finalTitleBar;
            }
        },

        methods: {
            fetchLoginStatus(){
                setTimeout(() => {
                    this.$store.dispatch('loggedUserModel/fetchLoggedUserInfo', () => {
                        if (!this.$store.state.loggedUserModel.isLoggedIn &&
                            ['ChatLayout'].indexOf(this.$route.name) > -1
                        ) {
                            this.$router.push('/');
                        }

                        if (this.$store.state.loggedUserModel.isLoggedIn) {
                            this.$socket.emit("setUserSocketData", this.$store.state.loggedUserModel.info);
                        }
                    });
                }, 2000);
            },

            setTitleBar(){
                document.title = this.titleBar;
            }
        },

        mounted(){
            this.fetchLoginStatus();
            this.setTitleBar();

            document.addEventListener('focus', () => {
                this.$store.state.titleBarModel.isVisible = true;
                if (this.$store.state.titleBarModel.alert) {
                    this.$store.state.titleBarModel.alert = undefined;
                }
            }, false);

            document.addEventListener('blur', () => {
                this.$store.state.titleBarModel.isVisible = false;
            }, false);

            window.addEventListener('focus', () => {
                this.$store.state.titleBarModel.isVisible = true;
                if (this.$store.state.titleBarModel.alert) {
                    this.$store.state.titleBarModel.alert = undefined;
                }
            }, false);

            window.addEventListener('blur', () => {
                this.$store.state.titleBarModel.isVisible = false;
            }, false);
        },

        sockets: {
            'onlineUsersUpdate'(data){
                this.$store.commit('onlineUsersModel/setOnlineUsers', data.onlineUsers)
            }
        },

        watch: {
            'titleBar'(){
                this.setTitleBar();
            }
        }
    }
</script>

<style>
    #app {
        height: 100%;
        display: block;
    }
</style>



// WEBPACK FOOTER //
// App.vue?15a0de78